export default "__VITE_ASSET__B$x7CMEy__"